<template>
  <div>
    <div class="menu-mask" v-if="isShow" @click.self="isShow = false">
      <div class="menu-list">
        <p class="menu-title">实时聊天对接</p>
        <div class="menu-item" v-for="item in list1" :key="item.title" @click="handlePush(item.code)">
          <img class="item-brand" :src="item.img" alt="">
          <span class="item-title">{{item.title}}</span>
          <img class="item-icon" src="@/assets/img/guide/gt.svg" alt="">
        </div>
        <p class="menu-title" style="margin-top: 24px;">线索对接</p>
        <div class="menu-item" v-for="item in list2" :key="item.title" @click="handlePush(item.code)" style="border-bottom:none">
          <img class="item-brand" :src="item.img" alt="">
          <span class="item-title">{{item.title}}</span>
          <img class="item-icon" src="@/assets/img/guide/gt.svg" alt="">
        </div>
      </div>
    </div>
    <img class="menu-icon" src="@/assets/img/guide/menu.svg" alt="" @click="isShow = true">
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow: false,
      list1: [
        {
          code: 'dy',
          title: '抖音企业号',
          img: require('@/assets/img/guide/brand/dy.png')
        },
        {
          code: 'wxgzh',
          title: '微信公众号',
          img: require('@/assets/img/guide/brand/wxgzh.svg')
        },
        {
          code: 'wxxcx',
          title: '微信小程序',
          img: require('@/assets/img/guide/brand/wxxcx.svg')
        },
        // {
        //   code: 'wxkf',
        //   title: '微信客服(视频号)',
        //   img: require('@/assets/img/guide/brand/wxkf.svg')
        // },
        // {
        //   code: 'weibo',
        //   title: '微博',
        //   img: require('@/assets/img/guide/brand/weibo.svg')
        // },
        {
          code: 'web',
          title: 'WEB端',
          img: require('@/assets/img/guide/brand/web.svg')
        },
        {
          code: 'h5',
          title: 'H5端',
          img: require('@/assets/img/guide/brand/h5.png')
        }
      ],
      list2: [
        {
          code: 'jlyq',
          title: '百度/巨量',
          img: require('@/assets/img/guide/brand/jlyq.svg')
        }
      ]
    };
  },
  methods: {
    handlePush(code) {
      this.$router.push({ name: 'guideMenu', params: { company: this.$route.params.company, code } });
      this.isShow = false;
    }
  }
};
</script>

<style  lang="scss" scoped>
.menu-icon{
  width: 60px;
  height: 60px;
  position: fixed;
  right: 10px;
  bottom: 116px;
}
.menu-mask{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2)
}
.menu-list{
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  width: 309px;
  height: 426px;
  background: #FFFFFF;
  border-radius: 6px;
  padding: 24px 18px;
  .menu-title{
    height: 13px;
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #9CA6B9;
    line-height: 13px;
    text-align: left;
  }
  .menu-item{
    height: 56px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(215, 220, 228, .6);
    .item-brand{
      width: 24px;
      height: 24px;
    }
    .item-title{
      height: 14px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #242934;
      line-height: 14px;
      margin-left: 12px;
      flex-grow: 1;
      text-align: left;
    }
    .item-icon{
      width: 12px;
      height: 12px;
    }
  }
}
</style>
